import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

const RadioButtons = ({ radioOptions, defaultOption, ...props }) => {
  const checked = radioOption => {
    return radioOption === defaultOption;
  };

  return (
    <fieldset>
      <div className="radio-buttons-container">
        {radioOptions.map(radioOption => (
          <div key={radioOption}>
            <div className="radio-button" key={radioOption}>
              <input
                id={radioOption}
                type="radio"
                name="radio-group"
                value={radioOption}
                checked={checked(radioOption)}
                {...props}
              />
              <label htmlFor={radioOption}>
                <p className="radio-button__label">{radioOption}</p>
              </label>
            </div>
          </div>
        ))}
      </div>
    </fieldset>
  );
};

RadioButtons.propTypes = {
  radioOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  defaultOption: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RadioButtons;
